import { parse } from "tldjs";

type BrowserLocation = Pick<Location, "protocol" | "host" | "hostname">;

/**
 * Resolves the app subdomain consistently for public-suffix domains and local
 * development hosts such as admin.localhost.
 */
export const resolveSubdomain = ({
  protocol,
  host,
  hostname,
}: BrowserLocation): string => {
  const parsed = parse(`${protocol}//${host}`);
  const subdomain = parsed.tldExists
    ? parsed.subdomain
    : parsed.isIp
    ? ""
    : hostname.split(".").slice(0, -1).join(".");

  return subdomain?.replace("www.", "") || "";
};
